import Booking from '@solvhealth/types/interfaces/Booking';
import Location from '@solvhealth/types/interfaces/Location';
import React, { PureComponent } from 'react';
import { ADD_REVIEW_TO_SOLV } from '../../../constants/index';
import AddReviewWarning from '../AddReviewWarning';
import PrimaryRatingSelector from '../../../components/LeaveAReview/components/PrimaryRatingSelector';
import RatingDescriptionForm from '../../../components/LeaveAReview/components/RatingDescriptionForm';
import SecondaryStarSelectors from '../../../components/LeaveAReview/components/SecondaryStarSelectors';
import {
  BEDSIDE_MANNER,
  FACILITY_CLEANLINESS,
  QUALITY_OF_CARE,
  STAFF_FRIENDLINESS,
  WAIT_TIME,
} from '../../../components/LeaveAReview/constants';
import { analyticsTrackEvent } from '../../../core/analytics';
import {
  ADD_REVIEW_LEAVE_REVIEW_ON_GOOGLE,
  ADD_REVIEW_SUBMIT,
} from '../../../core/analytics/events';
import withStyles from '../../../core/isomorphic-style-loader/withStyles';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module '../AddReview.css' or its corre... Remove this comment to see the full error message
import s from '../AddReview.css';
import FlowTransition from '../transitions/FlowTransition';

import ReviewHeader from '~/components/AddReview/ReviewHeader';
import { PRIMARY_RATING } from '../../../components/LeaveAReview/components/PrimaryRatingSelector';
import {
  CONSENT_FIELD,
  RATING_DESCRIPTION_FIELD,
} from '../../../components/LeaveAReview/constants';
import { goToGoogleReviewFlow } from '~/core/dapi/tracking';

type Props = {
  bookingId: string;
  booking: Booking;
  location: Location;
  review?: string;
  handleRatingChange?: (...args: any[]) => any;
  error?: any;
  flowState: string;
  googleUrl?: string;
  starRating?: number;
  submitReview?: (...args: any[]) => any;
  flowType: string;
  leaveAReview?: any;
  onStarChange?: (...args: any[]) => any;
  ratingDate?: string;
};

class ReviewOnSolvCollectorWithGoogleFooter extends PureComponent<Props> {
  getTrackingProperties = () => ({
    locationId: this.props.location.id,
    flowType: this.props.flowType,
    starRating: this.props.starRating,
    review: this.props.review,
    bookingId: this.props.bookingId,
  });

  handleSolvReviewSubmit = (form: any) => {
    const formData = {
      ...form,
      ...this.props.leaveAReview,
      bookingId: this.props.bookingId,
      locationId: this.props.location.id,
    };

    const formattedData = {
      starRating: formData[PRIMARY_RATING],
      review: formData[RATING_DESCRIPTION_FIELD],
      consentToPublish: formData[CONSENT_FIELD],
      ratingWaitTime: formData[WAIT_TIME],
      ratingBedsideManner: formData[BEDSIDE_MANNER],
      ratingStaffFriendliness: formData[STAFF_FRIENDLINESS],
      ratingQualityOfCare: formData[QUALITY_OF_CARE],
      ratingFacilityCleanliness: formData[FACILITY_CLEANLINESS],
      locationId: formData.locationId,
      bookingId: formData.bookingId,
      providerId: this.props.booking.providerId,
    };

    analyticsTrackEvent(ADD_REVIEW_SUBMIT, {
      ...formattedData,
      flowType: this.props.flowType,
    });

    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    this.props.submitReview(formattedData);
  };

  handleReviewOnGoogle = () => {
    analyticsTrackEvent(ADD_REVIEW_LEAVE_REVIEW_ON_GOOGLE, this.getTrackingProperties());

    goToGoogleReviewFlow(this.props.googleUrl!, this.props.bookingId);
    return null;
  };

  handlePrimaryStarChange = (updateObj: any) => {
    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    this.props.onStarChange(updateObj);

    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    this.props.handleRatingChange(updateObj.value);
  };

  renderCollectReviews = () => {
    const { location, leaveAReview, onStarChange } = this.props;

    return (
      <div className={s.collectContainer}>
        <ReviewHeader booking={this.props.booking} location={this.props.location} />

        <AddReviewWarning error={this.props.error} ratingDate={this.props.ratingDate} />

        <PrimaryRatingSelector
          leaveAReview={leaveAReview}
          onChange={this.handlePrimaryStarChange}
        />

        <SecondaryStarSelectors
          leaveAReview={leaveAReview}
          location={location}
          onChange={onStarChange}
        />

        <RatingDescriptionForm
          leaveAReview={leaveAReview}
          location={location}
          submit={this.handleSolvReviewSubmit}
        />

        <div className={s.reviewOnGoogleCopy}>
          or leave a review on{' '}
          <a className={s.footerLink} onClick={this.handleReviewOnGoogle}>
            Google
          </a>
        </div>
      </div>
    );
  };

  render() {
    return (
      <FlowTransition
        flowState={this.props.flowState}
        stateToActivateFlow={ADD_REVIEW_TO_SOLV}
        toRender={this.renderCollectReviews}
      />
    );
  }
}

export default withStyles(s)(ReviewOnSolvCollectorWithGoogleFooter);
